export default function DashboardPreview() {
  const dashboardFeatures = [
    {
      title: "Übersichtliches Dashboard",
      description: "Alle wichtigen Kennzahlen auf einen Blick – deine Stimmung, Fortschritte und nächste Schritte.",
      image: "https://public.readdy.ai/ai/img_res/732aa95d061beff07440a1586ee1f9e6.jpg",
      features: [
        "Tägliche Stimmungs-Übersicht",
        "Aktuelle Ziele und Fortschritte",
        "Personalisierte Empfehlungen"
      ]
    },
    {
      title: "Detaillierte Statistiken",
      description: "Verfolge deine Entwicklung mit interaktiven Diagrammen und erkenne Muster in deinem Verhalten.",
      image: "https://readdy.ai/api/search-image?query=person%20analyzing%20charts%20and%20graphs%20on%20tablet%20or%20laptop%20with%20interested%20focused%20expression%20discovering%20insights%20bright%20workspace%20with%20teal%20turquoise%20color%20accents%20natural%20light%20data%20visualization%20and%20personal%20analytics%20moment%20professional%20yet%20warm%20atmosphere%20lifestyle%20photography%20soft%20lighting&width=600&height=400&seq=dashboard-stats-person&orientation=landscape",
      features: [
        "Interaktive Diagramme",
        "Wöchentliche und monatliche Trends",
        "Vergleich über verschiedene Zeiträume"
      ]
    },
    {
      title: "Digitales Journal",
      description: "Schreibe deine Gedanken und Reflexionen in einem sicheren, verschlüsselten Raum auf.",
      image: "https://readdy.ai/api/search-image?query=person%20writing%20thoughtfully%20on%20laptop%20or%20tablet%20in%20cozy%20comfortable%20space%20peaceful%20reflective%20expression%20soft%20natural%20light%20teal%20turquoise%20cushions%20and%20decor%20elements%20private%20journaling%20moment%20calm%20serene%20atmosphere%20wellness%20and%20self-reflection%20lifestyle%20photography%20warm%20gentle%20lighting&width=600&height=400&seq=dashboard-journal-person&orientation=landscape",
      features: [
        "Ende-zu-Ende verschlüsselt",
        "KI-gestützte Reflexionsfragen",
        "Durchsuchbar und organisiert"
      ]
    },
    {
      title: "Ziel-Management",
      description: "Definiere und verfolge Ziele in 8 Lebensbereichen mit intelligenter KI-Unterstützung.",
      image: "https://readdy.ai/api/search-image?query=motivated%20person%20planning%20goals%20with%20notebook%20or%20digital%20device%20determined%20positive%20expression%20bright%20modern%20space%20with%20teal%20turquoise%20elements%20natural%20daylight%20goal%20setting%20and%20achievement%20planning%20moment%20inspiring%20productive%20atmosphere%20lifestyle%20photography%20professional%20warm%20lighting&width=600&height=400&seq=dashboard-goals-person&orientation=landscape",
      features: [
        "8 Lebensbereiche abdecken",
        "Fortschritts-Tracking in Echtzeit",
        "KI-generierte Handlungsempfehlungen"
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-teal-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-dashboard-line mr-2"></i>
            Dein persönliches Dashboard
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Alles an einem Ort – übersichtlich und intuitiv
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Dein Dashboard gibt dir einen vollständigen Überblick über deine persönliche Entwicklung
          </p>
        </div>

        <div className="space-y-24">
          {dashboardFeatures.map((feature, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                  <div className="w-full h-96">
                    <img
                      src={feature.image}
                      alt={feature.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
                  {feature.title}
                </h3>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  {feature.description}
                </p>

                <div className="space-y-4">
                  {feature.features.map((item, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-teal-600 text-sm"></i>
                      </div>
                      <p className="text-gray-700 text-base">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-20 text-center">
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-teal-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Erlebe dein Dashboard live
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Registriere dich jetzt kostenlos und entdecke alle Features in deinem persönlichen Dashboard
            </p>
            <a
              href="/dashboard"
              className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-teal-600 to-cyan-600 text-white text-lg font-semibold rounded-lg hover:from-teal-700 hover:to-cyan-700 transition-all shadow-lg hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-dashboard-line mr-2 text-xl"></i>
              Jetzt kostenlos starten
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
